import { isNullOrWhiteSpace } from "./string";

/**
 * Filter empty values (null, undefined, or empty strings).
 */
export const notEmpty = <T>(item: T | null | undefined): item is T => {
  if (item === null || item === undefined) {
    return false;
  }

  if (typeof item === "string" && isNullOrWhiteSpace(item as string)) {
    return false;
  }

  return true;
};
